import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { c as s } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as j } from "react";
import { I as A } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import { useInput as z } from "./input.hook.js";
import { INPUT_STATUS as t, ICONS_STATUS as u } from "./input.type.js";
const B = "_input_s9iwc_29", O = "_filled_s9iwc_48", P = "_error_s9iwc_154", R = "_counter_s9iwc_174", i = {
  input: B,
  "group-label": "_group-label_s9iwc_29",
  filled: O,
  "is-error": "_is-error_s9iwc_51",
  "is-success": "_is-success_s9iwc_54",
  "is-warning": "_is-warning_s9iwc_57",
  "helper-text": "_helper-text_s9iwc_60",
  "is-disabled": "_is-disabled_s9iwc_86",
  "is-full-width": "_is-full-width_s9iwc_101",
  "container-counter-icon": "_container-counter-icon_s9iwc_148",
  error: P,
  "container-icon": "_container-icon_s9iwc_157",
  counter: R,
  "dialog-overlay-show": "_dialog-overlay-show_s9iwc_1",
  "dialog-content-show": "_dialog-content-show_s9iwc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_s9iwc_1"
}, k = j(
  ({
    className: f,
    type: N = "text",
    value: d,
    message: l,
    status: c,
    placeholder: v,
    onChange: g,
    onBlur: a,
    disabled: n,
    label: _,
    helperText: w,
    name: I,
    isFullWidth: S,
    defaultValue: p,
    id: x,
    optionalMessage: m,
    maxLength: e,
    ...y
  }, C) => {
    const {
      valueCounter: h,
      handleBlur: T,
      handleChange: U
    } = z(
      d?.toString(),
      p?.toString(),
      g,
      a ? () => a({}) : void 0
    ), b = s(
      i.input,
      c && i[t[c]],
      n && i["is-disabled"],
      S && i["is-full-width"],
      f
    );
    return /* @__PURE__ */ o("div", { className: b, children: [
      /* @__PURE__ */ o("div", { className: i["group-label"], children: [
        /* @__PURE__ */ o("div", { children: [
          _ && /* @__PURE__ */ r("label", { className: s(c && i[c]), children: _ }),
          m && /* @__PURE__ */ r("span", { children: m })
        ] }),
        w && /* @__PURE__ */ r("div", { className: i["helper-text"], children: w })
      ] }),
      /* @__PURE__ */ r(
        "input",
        {
          id: x,
          ref: C,
          value: d,
          className: s(c && !n && i[t[c]]),
          type: N,
          placeholder: v,
          onChange: U,
          onBlur: T,
          name: I,
          defaultValue: p,
          "aria-label": _,
          disabled: n,
          ...y
        }
      ),
      (l && c && !n || e) && /* @__PURE__ */ o("div", { className: i["container-counter-icon"], children: [
        l && c && !n && /* @__PURE__ */ o("div", { className: i["container-icon"], children: [
          /* @__PURE__ */ r(A, { name: u[c].name, size: "medium", color: u[c].color }),
          /* @__PURE__ */ r("span", { className: i[t[c]], children: l })
        ] }),
        e && /* @__PURE__ */ o("div", { className: s(i.counter, h > e && i.error), children: [
          h,
          "/",
          e
        ] })
      ] })
    ] });
  }
);
k.displayName = "Input";
export {
  k as Input
};
